<div class="app-shell">
  <router-outlet></router-outlet>
</div>
